import { IconButton } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { useProjectSummaryToggleStyles } from './project-summary-toggle.styles';

export interface ProjectSummaryToggleProps {
  isOpen: boolean;
  onToggle: (open: boolean) => void;
}

export function ProjectSummaryToggle(props: ProjectSummaryToggleProps) {
  const classes = useProjectSummaryToggleStyles();
  return (
    <>
      <IconButton
        classes={{
          root: classes.iconButton
        }}
        onClick={() => props.onToggle(!props.isOpen)}
        aria-label="project summary"
        size="medium"
      >
        <InfoOutlined className={classes.icon} />
      </IconButton>
    </>
  );
}
